import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";

type SmsConsentConfirmationProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  error?: string | null;
  className?: string;
};

export const SMS_TRANSACTIONAL_CONSENT_LABEL =
  "I confirm this customer agreed to receive transactional SMS updates for this project.";

export const SMS_TRANSACTIONAL_CONSENT_REQUIRED_MESSAGE =
  "Confirm customer SMS consent before sending transactional SMS.";

export function SmsConsentConfirmation({
  checked,
  onCheckedChange,
  error,
  className,
}: SmsConsentConfirmationProps) {
  return (
    <div
      className={cn(
        "border-l-2 border-border/70 py-1 pl-3 pr-1",
        error ? "border-destructive bg-destructive/5" : "",
        className,
      )}
    >
      <label className="flex items-start gap-2 text-sm font-medium leading-snug text-foreground">
        <Checkbox
          checked={checked}
          onCheckedChange={(value) => onCheckedChange(Boolean(value))}
          className="mt-px"
        />
        <span>{SMS_TRANSACTIONAL_CONSENT_LABEL}</span>
      </label>
      {error ? <p className="mt-1 pl-6 text-xs font-medium text-destructive">{error}</p> : null}
    </div>
  );
}
